// Size Attribute
export enum EKwikUIInputSize {
  S = "s",
  M = "m",
  L = "l"
}
export const VKwikUIInputSize = [
  EKwikUIInputSize.S,
  EKwikUIInputSize.M,
  EKwikUIInputSize.L
] as const;

export type TKwikUIInputSize = (typeof VKwikUIInputSize)[number];
